ALLOWED_CONTROLLER = 'latches'
ALLOWED_ACTIONS = ['make_it_rented_request', 'make_it_rented']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)
  ammountField = $("#node_state_change_request_amount")
  chargeNormalAmmountCheckbox = $("#node_state_change_request_charge_normal_amount")

  disableAmmountFieldIfCheckboxIsChecked = ->
    ammountField.prop('disabled', chargeNormalAmmountCheckbox.prop("checked"))

  disableAmmountFieldIfCheckboxIsChecked()
  chargeNormalAmmountCheckbox.on 'change', -> disableAmmountFieldIfCheckboxIsChecked()

$(document).ready(ready)
$(document).on('turbo:load', ready)
